/**
 * @file: index.tsx
 *
 * `ArchivedFeedThreadsScreen` — the navigator binding for the archived feed
 * threads list. Pushed over the inbox; the nav header supplies the title.
 */

import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { ArchivedThreadsView } from './components/ArchivedThreadsView';

export const ArchivedFeedThreadsScreen = wrapNavigatorScreen(
  ArchivedThreadsView,
  { title: '已归档' },
);
